import React from 'react';
import Typewriter from 'typewriter-effect';
import './Typing.css'

const Typing = () => {
    
    return (
        <div >
            <div className="typing flex flex-col items-center justify-center text-white">
                Front-end Web Developer with <br />
                <span className='flex'>
                    Expertise on
                    <span className='ml-1 md:ml-3 font-bold font-mono'>
                        <Typewriter
                            options={{
                                strings: [
                                    '<span style="color:#61DAFB">React</span>',
                                    '<span style="color:#EFD81D">JavaScript</span>',
                                    '<span style="color:#DD4B25">HTML5</span>',
                                    '<span style="color:#254BDD">CSS3</span>',
                                    '<span style="color:#6F10F4">Bootstrap</span>',
                                    '<span style="color:#07B6D5">Tailwind</span>',
                                ],
                                autoStart: true,
                                loop: true,
                            }}
                        />
                    </span>
                </span>
            </div>
        </div>
    );
};

export default Typing;
